module.exports = __webpack_public_path__ + "slogan.png?f13e9386228bc6da471bc6caf5c6259f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slogan.png
// module id = 122
// module chunks = 0